import { Injectable } from '@angular/core';
import { DropdownOption } from '../../../../../../core/models/dropdown-option';
import { DropdownService } from '../../../../../../core/services/resources/dropdown.service';
import { OrderStatus } from '../../constants/order-status';

@Injectable({
    providedIn: 'root',
})
export class OrderFormService {
    constructor(private readonly dropdownService: DropdownService) {}

    /**
     * Returns a list of dropdown options for order statuses, with options disabled based on allowed transitions.
     */
    getStatusTransitionDropdownOptions(
        allowedTransitions: Partial<
            Record<keyof typeof OrderStatus, OrderStatus[]>
        >,
        currentStatus: OrderStatus | null,
    ): DropdownOption[] {
        const allOrderStatusOptions =
            this.dropdownService.getOrderStatusOptions();

        // If there is no current status, then all options should be enabled.
        if (!currentStatus) {
            return allOrderStatusOptions;
        }

        const currentOrderStatusKey = OrderStatus[
            currentStatus
        ] as keyof typeof OrderStatus;
        const validOrderStatusTransitions =
            allowedTransitions[currentOrderStatusKey];

        return allOrderStatusOptions.map((option) => {
            /**
             * An option is enabled only if it is included in the list of valid transitions
             * from the current order status. If an option is not in that list, then all of the dropdown options
             * are disabled.
             */
            const isTransitionAllowed =
                validOrderStatusTransitions?.includes(
                    option.value as OrderStatus,
                ) ?? false;

            return {
                ...option,
                disabled: !isTransitionAllowed,
            };
        });
    }
}
